import { forwardRef } from 'react'
import { Badge as MuiBadge, type BadgeProps as MuiBadgeProps } from '@mui/material'

export type BadgeProps = MuiBadgeProps

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(props, ref) {
  return <MuiBadge ref={ref} {...props} />
})
